import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";

import Sidebar from "arui-feather/sidebar";
import AnswerForm from "../forms/AnswerForm";

export default function UserQuestionnairesPanel(props) {
    const [questionnaires, setQuestionnaires] = useState([]);
    const [loading, setLoading] = useState(false);
    const [answers, setAnswers] = useState([]);
    const [selectedId, setSelectedId] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        axios.get(`/my-answers`).then(d => d.data).then(arr => {
            setAnswers(arr);
            axios.get(`/questionnaires`).then(d => d.data).then(arr2 => {
                setQuestionnaires(arr2);
                setLoading(false);
            });
        });
    }, []);

    if (loading == true) {
        return (
            <div>
                ...
            </div>
        );
    }

    let selectedItem = (questionnaires.filter(x => (x.id == selectedId)))[0];
    let selectedAnswer = (answers.filter(x => (x.questionnaireId == selectedId)))[0];

    return (
        <Wrapper>

            {/*{questionnaires.length == 0 ? null :*/}
            {/*    <h1>*/}
            {/*        Опросники*/}
            {/*    </h1>*/}
            {/*}*/}

            {questionnaires.map((a, i) => {
                let ans = answers.filter(x => (x.questionnaireId == a.id))[0];
                return (
                    <Row key={a.id} onClick={() => {
                        setSelectedId(a.id);
                    }}>
                        <Name>
                            {a?.details?.name}
                        </Name>
                        <TextPlaceholdet>
                            {a?.details?.question}
                        </TextPlaceholdet>

                        <div style={{ marginTop: 10, cursor: "pointer" }}>
                            {ans == undefined ? "Пройти опрос" : `Ответ: ${ans?.answer}`}
                        </div>
                    </Row>
                );
            })}

            <Sidebar visible={(selectedItem != undefined)} onCloserClick={() => {
                setSelectedId(undefined);
            }}>

                <div>
                    {selectedItem?.text}
                </div>

                <AnswerForm
                    {...selectedAnswer}
                    onSave={async x => {
                        await axios.post(`/questionnaires/${selectedItem?.id}/answer`, {
                            answer: x.answer
                        });
                        let arr = (await axios.get(`/my-answers`)).data;
                        setAnswers(arr);
                        window.alert("Ответ сохранен");
                        setSelectedId(undefined);
                    }}
                />

            </Sidebar>


        </Wrapper>
    );
}

const Wrapper = styled.div`

`;

const TextPlaceholdet = styled.div`

`;

const Row = styled.div`
  margin-bottom: 15px;
`;

const Name = styled.div`
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: bold;
`;